import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { db, FirebaseTimestamp } from "../firebase/index";
import { doc, getDoc } from "firebase/firestore";
import { makeStyles } from "@material-ui/core";
import { returnCodeToBr } from "../functions/common";
import { ImageSwiper, SizeTable } from "../components/products/";
import {
  addProductToCart,
  addProductToFavorite,
} from "../reducks/users/operations";
import { getMakers } from "../reducks/makers/selectors";
import { getShops } from "../reducks/shops/selectors";
import { getCategories } from "../reducks/categories/selectors";
import { fetchMakers } from "../reducks/makers/operations";
import { fetchShops } from "../reducks/shops/operations";
import { fetchCategories } from "../reducks/categories/operations";
import { buildLineFromProduct } from "../functions/cart/cartLine";

const useStyle = makeStyles((theme) => ({
  sliderBox: {
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto 24px auto",
      height: 320,
      width: 320,
    },
    [theme.breakpoints.up("sm")]: {
      margin: "0 auto",
      height: 400,
      width: 400,
    },
  },
  detail: {
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto 16px auto",
      height: "auto",
      width: 320,
    },
    [theme.breakpoints.up("sm")]: {
      margin: "0 auto",
      height: "auto",
      width: 400,
    },
  },
  price: {
    color: theme.palette.warning.main,
    fontSize: 36,
  },
}));

const ProductDetail = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [product, setProduct] = useState(null);
  // const selector = useSelector((state) => state);
  // const path = selector.router.location.pathname;
  const path = useSelector((state) => state.router.location.pathname);
  const makers = useSelector(getMakers);
  const shops = useSelector(getShops);
  const categories = useSelector(getCategories);
  const [makerName, setMakerName] = useState("");
  const [isMasterLoadFailed, setIsMasterLoadFailed] = useState(false);

  // 商品一覧を経由せずに開いた場合(再読み込み・注文履歴からの遷移)にもマスタを揃える。
  // 未読み込みのまま追加すると販売店名などがundefinedになり、カート・お気に入りへの書き込みが拒否される。
  useEffect(() => {
    let cancelled = false;
    Promise.all([
      dispatch(fetchCategories()),
      dispatch(fetchShops()),
      dispatch(fetchMakers()),
    ]).catch((error) => {
      console.error("商品マスタの読み込みに失敗しました:", error);
      if (!cancelled) setIsMasterLoadFailed(true);
    });
    return () => {
      cancelled = true;
    };
  }, [dispatch]);
  const isMasterReady =
    categories.length > 0 && shops.length > 0 && makers.length > 0;

  const id = path.split("/product/")[1];
  useEffect(() => {
    const getProduct = async () => {
      const docRef = doc(db, "products", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setProduct(docSnap.data());
      } else {
        console.log("No such document!");
      }
    };

    getProduct();
  }, []);
  useEffect(() => {
    if (makers && product) {
      const maker_name = makers
        .filter((maker) => maker.mid === product.maker)
        .map((maker) => maker.name);
      console.log("maker_name", makers, product);
      setMakerName(maker_name[0]);
    }
  }, [makers, product]);
  const buildLine = useCallback(
    (selectedItem) =>
      buildLineFromProduct({
        product,
        selectedItem,
        shops,
        makers,
        categories,
        addedAt: FirebaseTimestamp.now(),
      }),
    [product, shops, makers, categories]
  );

  // SizeTable側で書き込み完了を待てるようにthunkのPromiseを返す
  const addProduct = useCallback(
    (selectedItem) => dispatch(addProductToCart(buildLine(selectedItem))),
    [dispatch, buildLine]
  );

  const addFavorite = useCallback(
    (selectedItem) => {
      dispatch(addProductToFavorite(buildLine(selectedItem)));
    },
    [dispatch, buildLine]
  );

  return (
    <section className="c-section-wrapin">
      {/* 読み込み済みのマスタがあれば操作を続けられるため、案内は揃っていないときだけ出す */}
      {isMasterLoadFailed && !isMasterReady && (
        <p>
          商品情報の読み込みに失敗しました。通信環境をご確認のうえ、ページを再読み込みしてください。
        </p>
      )}
      {/* マスタが揃うまではカート・お気に入りへ追加できないよう表示しない */}
      {product && isMasterReady && (
        <div className="p-grid__row">
          <div className={classes.sliderBox}>
            <ImageSwiper images={product.images} />
          </div>
          <div className={classes.detail}>
            <h2 className="u-text__headline__small">社内品番 {product.idin}</h2>
            <h2 className="u-text__headline">{product.name}</h2>
            <h2 className="u-text__medium__headline">{makerName}</h2>
            <p className={classes.price}>{product.price}</p>
            {/* <p className={classes.price}>￥{product.price.toLocaleString()}</p> */}
            <div className="module-spacer--small" />
            <p>{returnCodeToBr(product.description)}</p>
            <div className="module-spacer--small" />
            <SizeTable
              addProduct={addProduct}
              addFavorite={addFavorite}
              sizes={product.sizes}
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductDetail;
